import React from 'react'

const Icons = ({ children }) => {
    return (
        <div className='w-[60px] h-[60px] flex items-center justify-center bg-primary rounded-full'>{children}</div>
    )
}

export default Icons